import {
  MOBILE_BACK_BUTTON_HEIGHT,
  TABLET_BACK_BUTTON_HEIGHT,
  LAPTOP_BACK_BUTTON_HEIGHT,
} from '../../constants';

export const calculateTopPadding = (topPadding, isBackButtonVisible, type) => {
  if (type === 'mobile') {
    return isBackButtonVisible
      ? topPadding + MOBILE_BACK_BUTTON_HEIGHT
      : topPadding;
  }
  if (type === 'tablet') {
    return isBackButtonVisible
      ? (topPadding * 0.6) + TABLET_BACK_BUTTON_HEIGHT // prettier-ignore
      : topPadding * 0.6;
  }
  return isBackButtonVisible
    ? topPadding + LAPTOP_BACK_BUTTON_HEIGHT
    : topPadding;
};

export default calculateTopPadding;
